import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: "headline",
  class: "path-headlines"
}
const _hoisted_2 = { key: 3 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No segment selected", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: "path-view-buttons",
  class: "row row--buttons justify-content-between"
}
const _hoisted_6 = { class: "col-lg-auto ml-auto ms-auto" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fal fa-arrow-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline_path_segment_view = _resolveComponent("headline-path-segment-view")!
  const _component_simple_path_segment_view = _resolveComponent("simple-path-segment-view")!
  const _component_package_path_segment_view = _resolveComponent("package-path-segment-view")!
  const _component_additional_options_path_segment_view = _resolveComponent("additional-options-path-segment-view")!

  return (_ctx.displayedSegments !== undefined)
    ? (_openBlock(), _createBlock(_TransitionGroup, {
        key: 0,
        appear: "",
        name: "fade"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedHeadlineSegments, (headlineSegment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "path-segment path-segment--headline"
              }, [
                _createVNode(_component_headline_path_segment_view, { segment: headlineSegment }, null, 8, ["segment"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            key: "path-view-wrapper",
            class: _normalizeClass([[{'is-mobile': _ctx.isMobile}], "path-view-wrapper"])
          }, [
            _createElementVNode("div", {
              key: "path-view",
              class: _normalizeClass([[{'is-mobile': _ctx.isMobile},
                 `row-cols-xxl-${_ctx.columns}`,
                 {'no-gutters': _ctx.columnsNoGutter}
                 ], "row path-view row-cols-1 row-cols-md-2"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedSegmentsNoHeadlines, (pathSegment, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([[
                {'col': !_ctx.isAdditionalOptionsSegment(pathSegment)},
                {'col-12': _ctx.isAdditionalOptionsSegment(pathSegment)},
                `path-segment--${pathSegment.alias} path-segment--${_ctx.getTypeClass(pathSegment)}`
            ], "path-segment"])
                }, [
                  (_ctx.isSimpleSegment(pathSegment))
                    ? (_openBlock(), _createBlock(_component_simple_path_segment_view, {
                        key: 0,
                        segment: pathSegment
                      }, null, 8, ["segment"]))
                    : (_ctx.isPackageSegment(pathSegment))
                      ? (_openBlock(), _createBlock(_component_package_path_segment_view, {
                          key: 1,
                          segment: pathSegment
                        }, null, 8, ["segment"]))
                      : (_ctx.isAdditionalOptionsSegment(pathSegment))
                        ? (_openBlock(), _createBlock(_component_additional_options_path_segment_view, {
                            key: 2,
                            segment: pathSegment
                          }, null, 8, ["segment"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                ], 2))
              }), 128))
            ], 2)
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                disabled: !_ctx.isAdditionalOptionsSegment(_ctx.displayedSegmentsNoHeadlines[0]) && _ctx.displayedSegmentsNoHeadlines.filter(segment => segment.chosen).length === 0,
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitSelection && _ctx.submitSelection(...args)))
              }, [
                (_ctx.isAdditionalOptionsSegment(_ctx.displayedSegmentsNoHeadlines[0]))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Zur Preisschätzung"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "Weiter")),
                _hoisted_10,
                _hoisted_11
              ], 8, _hoisted_7)
            ])
          ])
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}